import { Alert, Spin } from "antd";
import dayjs from "dayjs";
import { LoadingOutlined } from "@ant-design/icons";
import { useCalendarIssues } from "components/CalendarIssues/context";

const CalendarIssue = () => {
  const { is_loading_calendar_issue, calendar_issue, setCalendarIssueId } =
    useCalendarIssues();

  if (is_loading_calendar_issue) {
    return (
      <Alert
        style={{
          marginBottom: 10,
          padding: 20,
          maxWidth: 500,
          textAlign: "center",
          margin: "0 auto",
        }}
        message={
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 40,
                }}
                spin
              />
            }
          />
        }
      />
    );
  }

  if (!calendar_issue) {
    return null;
  }

  return (
    <Alert
      style={{ marginBottom: 10, maxWidth: 500, margin: "0 auto" }}
      closable
      onClose={() => setCalendarIssueId(null)}
      message={
        <>
          <p className="m-0">
            Ulica:{" "}
            <strong>
              {calendar_issue?.client_street}{" "}
              {calendar_issue?.client_building_number}/
              {calendar_issue?.client_apartment_number}
            </strong>
          </p>
          <p className="m-0">
            Miejscowość: <strong>{calendar_issue?.client_city}</strong>
          </p>
          <p className="m-0">
            Data umówienia:{" "}
            <strong>
              {" "}
              {calendar_issue?.service_date
                ? dayjs(calendar_issue.service_date).format("DD-MM-YYYY HH:mm")
                : "-"}
            </strong>
          </p>
        </>
      }
    />
  );
};

export default CalendarIssue;
